// Magic feature constants — extracted from DoozyGoMagic.js for reuse + smaller component
export const PACKAGES = [
  { name: "Basic", price: "3,999", accent: "#10b981", gradient: "from-emerald-500 to-teal-600", desc: "Balloon bunch + Banner + Table decor" },
  { name: "Classic", price: "5,999", accent: "#3b82f6", gradient: "from-blue-500 to-indigo-600", desc: "Balloon arch + Theme colors + Cake table setup" },
  { name: "Premium", price: "8,999", accent: "#8b5cf6", gradient: "from-purple-500 to-violet-600", desc: "Theme decor + Backdrop + LED name board + Fairy lights" },
  { name: "Luxury", price: "14,999", accent: "#f59e0b", gradient: "from-amber-500 to-orange-600", desc: "Premium theme + Entry decor + LED lighting + Full setup" },
  { name: "Custom", price: "You decide", accent: "#E83E8C", gradient: "from-[#E83E8C] to-rose-600", desc: "Build Your Party — pick exactly what you want" },
];

export const OCCASIONS = ["Birthday", "Anniversary", "Baby Shower", "Engagement", "Housewarming", "Other"];

export const COLOR_PRESETS = [
  { name: "Rose Gold & Blush", value: "rose gold, blush pink, champagne, warm white" },
  { name: "Royal Blue & Gold", value: "royal blue, gold, white, navy accents" },
  { name: "Pastel Rainbow", value: "soft pink, lavender, mint, baby yellow, sky blue" },
  { name: "Black & Gold Glam", value: "black, gold, champagne, crystal white" },
  { name: "Tropical Fiesta", value: "coral, teal, golden yellow, palm green" },
  { name: "Elegant White", value: "all white, ivory, silver, pearl accents" },
];

export const ADDON_CATEGORIES = [
  { label: "Decor Boosters", items: [
    { id: "led_hbd", name: 'LED "Happy Birthday" Neon', price: 799 },
    { id: "led_name", name: "Customized Name LED", price: 1499 },
    { id: "balloons_100", name: "Extra 100 Balloons", price: 499 },
    { id: "balloons_chrome", name: "Premium Chrome/Pastel Balloons", price: 699 },
    { id: "balloon_ceiling", name: "Balloon Ceiling Decoration", price: 999 },
    { id: "balloon_gate", name: "Entrance Balloon Gate", price: 1499 },
    { id: "fairy_lights", name: "Fairy String Lights", price: 599 },
    { id: "flower_arrangement", name: "Floral Arrangement", price: 899 },
  ]},
  { label: "Cake & Sweets", items: [
    { id: "cake_designer", name: "1 Kg Designer Cake", price: 1200 },
    { id: "cake_photo", name: "Photo Cake", price: 1500 },
    { id: "cupcakes", name: "Cupcake Set (6 pcs)", price: 600 },
    { id: "cake_styling", name: "Cake Table Premium Styling", price: 799 },
  ]},
  { label: "Capture & Experience", items: [
    { id: "photographer", name: "Photographer Setup", price: 2500 },
    { id: "polaroid", name: "Instant Polaroid Corner", price: 1499 },
    { id: "surprise_entry", name: "Surprise Entry Setup", price: 999 },
    { id: "confetti_blast", name: "Confetti Blast Moment", price: 799 },
    { id: "sparkle_candle", name: "Sparkle Candle Entry", price: 499 },
  ]},
];
